import type { FamilyMemberType } from 'APP/Services/Scribe/types'

type PartialMemberProfile = {
  familyName?: string | null
  givenName?: string | null
  type?: FamilyMemberType
}

export enum ConsentState {
  Displayed = 'displayed',
  Accept = 'accept',
  NotApplicable = 'not_applicable',
}

export interface FormState {
  member: PartialMemberProfile
  loaded: boolean | null
  state: ConsentState | null
  uri: string
}
